import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../../services/api';
// import logo from '../../../styles/logo.png';
import { logoBase64 } from '../../../styles/logoBase64';
import { Menu, MenuItem } from '@mui/material';
import {
  FaLanguage
} from 'react-icons/fa';
const PermissionCheck = ({ type, lockId, onPermissionSuccess, visitorData }) => {
  const { t, i18n } = useTranslation();
  const [currentCheck, setCurrentCheck] = useState('');
  const [isChecking, setIsChecking] = useState(true);
  const [checkingTitle, setCheckingTitle] = useState('');
  const [, setError] = useState(false);
  const [pos, setPos] = useState({
    latitude: 0,
    longitude: 0
  });
  const [langMenuAnchor, setLangMenuAnchor] = useState(null);

  const handleLangMenuOpen = (event) => {
    setLangMenuAnchor(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangMenuAnchor(null);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    handleLangMenuClose();
  };
  const checkMicrophone = async () => {
    setError(false);
    setCurrentCheck(t('Checking microphone access...'));
    try {
      setCheckingTitle(t('Checking microphone...'));
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true
        }
      });
      // Stop audio tracks
      stream.getTracks().forEach(track => track.stop());
      return true;
    } catch (error) {
      console.error('Microphone error:', error);
      if (error.name === 'NotAllowedError') {
        throw new Error(t('Please allow microphone access'));
      } else if (error.name === 'NotFoundError') {
        throw new Error(t('Microphone not found'));
      } else if (error.name === 'NotReadableError') {
        throw new Error(t('Cannot access your microphone'));
      }
      throw error;
    }
  };

  const checkGeolocation = async () => {
    setError(false);
    setCurrentCheck(t('Detecting your location...'));
    try {
      setCheckingTitle(t('Getting location...'));
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        });
      });
      return position;
    } catch (error) {
      console.error('Location error:', error);
      if (error.name === 'GeolocationPositionError') {
        throw new Error(t('Please allow location access'));
      }
      throw error;
    }
  };

  const checkLocation = async (type, lockId, latitude, longitude) => {
    setError(false);
    setCurrentCheck(t('Verifying your location...'));
    try {
      setCheckingTitle(t('verifying location...'));
      const response = await axios.post(`/visitor/check-access`, {
        type,
        lockId,
        latitude,
        longitude
      },
        {
          skipErrorHandler: true
        }
      );
      if (response.data?.success) {
        setIsChecking(false);
        setCurrentCheck(`${response.data?.data?.distance}m`);
        setCheckingTitle(t('Location verified'));
      } else {
        setCurrentCheck(`${response.data?.distance}m`);
        setCheckingTitle(t('Exceeding the service distance'));
      }
    } catch (error) {
      console.error('Location check error:', error);
      throw new Error(t('Error checking location'));
    }
  };

  const checkPermissions = async () => {
    setIsChecking(true);
    try {
      // Check microphone first
      await checkMicrophone();

      // Then check geolocation
      const position = await checkGeolocation();
      setPos({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      });
      // Finally verify location with backend
      await checkLocation(
        type,
        lockId,
        position.coords.latitude,
        position.coords.longitude
      );

    } catch (error) {
      console.error('Permission check error:', error);
      setError(true);
      setCheckingTitle(error.message || t('Error accessing required permissions'));
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  useEffect(() => {
    checkPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed flex h-full w-full bg-white items-center justify-center z-50 px-2">
      <div className="bg-white flex flex-wrap items-center justify-center p-2 w-full">
        <button
          onClick={handleLangMenuOpen}
          className="text-white/70 hover:text-white p-2 rounded transition-colors absolute"
          style={{
            top: '20px',
            right: '20px'
          }}
        >
          <FaLanguage className="text-2xl text-black" />
        </button>
        <Menu
          anchorEl={langMenuAnchor}
          open={Boolean(langMenuAnchor)}
          onClose={handleLangMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={() => changeLanguage('en')}>English</MenuItem>
          <MenuItem onClick={() => changeLanguage('zh')}>中文</MenuItem>
          <MenuItem onClick={() => changeLanguage('zhCn')}>中文(简体)</MenuItem>
        </Menu>
        <div className="visitor-title w-full text-center">
          QRTalkie
        </div>
        <div className="scan-wrap w-full flex items-center justify-center">
          <img src={logoBase64} alt="logo" />
        </div>
        <div className="w-full text-center visitor-subtitle">
          <div className="w-full">{t('Service')}: {t('lat')}: {visitorData?.latitude} {t('long')}: {visitorData?.longitude}</div>
          <div className="w-full">{t('User')}: {t('lat')}: {pos?.latitude} {t('long')}: {pos?.longitude}</div>
          {currentCheck}
        </div>
        <div className="w-full text-center visitor-location">
          {checkingTitle}
        </div>
        <div className="visitor-button-container">
          {/* <button id="requestPermissionButton" onClick={checkPermissions}>{t('Request Permission')}</button> */}
          <button id="requestOpenDoorButton" onClick={() => onPermissionSuccess()} disabled={isChecking}>{t('Request Open Door')}</button>
        </div>
        <div className="w-full text-center visitor-location">
          {t('If location and microphone usage permissions have not been granted, please refresh the page and re authorize!')}
        </div>
        <div className="w-full text-center underline cursor-pointer text-blue-500 mt-[20px] text-[14px]" onClick={handleRefresh}>
          {t('Refresh page')}
        </div>
      </div>
    </div>
  );
};

export default PermissionCheck;
